export const Platform = {
    OS: 'web',
    select: (options) => options.web ?? options.default
};
export const NativeModules = {
    AppInfo: {},
    ExternalAPI: {
        sendEvent: () => undefined
    }
};
export const Alert = {
    alert: () => undefined
};
export const Linking = {
    openURL: (url) => {
        if (typeof window !== 'undefined' && window.open) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
};
export const Vibration = {
    vibrate: () => undefined
};
export class NativeEventEmitter {
    addListener() {
        return {
            remove: () => undefined
        };
    }
    removeAllListeners() {
        return undefined;
    }
}
